export enum QueryDirective {
  GET = 'pdbGet',
  BULK_GET = 'pdbBulkGet',
  ALL_DOCS = 'pdbAllDocs',
  PLUGIN = 'pdbPlugin',
  QUERY = 'pdbQuery'
}
